import { ClientTable } from 'vue-tables-2';
import { select } from '../shared/utils/dom';

export default function () {
  const table = select('#vue-tables-2');

  // currently this should work with the vue-tables-2.html template
  if (table) {
    Vue.use(ClientTable);
    const row = function (date) {
      return {
        'Date': date, // eslint-disable-line quote-props
        'Reading': '657', // eslint-disable-line quote-props
        'Method': 'Actual', // eslint-disable-line quote-props
        'Avg. Temp.': '0.3',
        'Number of Days': Math.floor(Math.random() * (31 - 29)) + 29,
        'Units Used': '87.56',
        'Bill Amount': '$32.56',
        'Yearly Usage +/-': '+0.3%',
        'Cost per Day': '$1.48',
      };
    };
    new Vue({ // eslint-disable-line no-new
      el: table,
      data: {
        columns: [
          'Date',
          'Reading',
          'Method',
          'Avg. Temp.',
          'Number of Days',
          'Units Used',
          'Bill Amount',
          'Yearly Usage +/-',
          'Cost per Day',
        ],
        tableData: [
          row('May 15, 2017'),
          row('April 16, 2017'),
          row('March 15, 2017'),
          row('February 15, 2017'),
          row('January 10, 2017'),
          row('December 10, 2016'),
          row('November 10, 2016'),
          row('October 10, 2016'),
          row('September 10, 2016'),
          row('August 10, 2016'),
          row('July 10, 2016'),
          row('June 10, 2016'),
          row('May 10, 2016'),
          row('April 10, 2016'),
        ],
        options: {
          filterable: false,
          orderBy: {
            column: 'Date',
          },
          perPage: 7,
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/tables.js